import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { toast } from '@/shared/ui/toast'
import { usePublishDocument } from '../api/publish'

interface PublishDocumentButtonProps {
  documentId: string
}

export function PublishDocumentButton({ documentId }: PublishDocumentButtonProps) {
  const publish = usePublishDocument(documentId)
  return (
    <Button
      variant="secondary"
      size="sm"
      disabled={publish.isPending}
      onClick={() =>
        publish.mutate(undefined, {
          onSuccess: () => toast.success('Документ опубликован'),
          onError: () => toast.error('Не удалось опубликовать'),
        })
      }
    >
      <Icon name="check" size={16} />
      Опубликовать
    </Button>
  )
}
